import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import styledMui from "utils/styled_mui";

export default styledMui(KeyboardArrowUpIcon, "isExpanded")`
  transition: transform 300ms;
  ${props => !props.isExpanded && "transform: rotate(-180deg);"}
`;
